import MyAccountContent from "../components/au.desktop/my-account-content";
import FinancingNotFound from "../components/au.desktop/financing-not-found";
import MyAccountTradeIn from "../components/au.desktop/my-account-trade-in";

export const myAccountRoutes = {
    myAccount: {
        key: "myAccount",
        name: "Basic details",
        route: "",
        component: MyAccountContent,
        showMenuSidebar: true
    },
    financing: {
        key: "financing",
        name: "Financing",
        route: "financing",
        component: FinancingNotFound,
        showMenuSidebar: true
    },
    tradeIn: {
        key: "tradeIn",
        name: "Sell or Trade-in your car",
        route: "trade-in",
        component: MyAccountTradeIn,
        showMenuSidebar: true
    }
};

export const myAccountRoutesArray = ["myAccount", "financing", "tradeIn"];

